import { Component, inject } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { AppUpdateService } from '@app/core/services/app-update.service';

@Component({
    selector: 'app-required-update',
    standalone: true,
    imports: [DialogModule, ButtonModule],
    template: `
        <p-dialog
            header="Actualización del sistema"
            [visible]="updates.required()"
            [modal]="true"
            [closable]="false"
            [closeOnEscape]="false"
            [dismissableMask]="false"
            [draggable]="false"
            [resizable]="false"
            [blockScroll]="true"
            [baseZIndex]="20000"
            appendTo="body"
            [style]="{ width: '28rem', maxWidth: 'calc(100vw - 2rem)' }"
        >
            <p role="alert">Hay una nueva versión disponible. Para continuar usando el sistema, presioná Actualizar.</p>
            <p>La página se recargará. Los cambios que no hayas guardado podrían perderse.</p>
            @if (updates.error()) {
                <p role="alert" class="text-red-600">{{ updates.error() }}</p>
            }
            <ng-template #footer>
                <p-button label="Actualizar" icon="pi pi-refresh"
                    [loading]="updates.updating()" [disabled]="updates.updating()"
                    (onClick)="updates.update()" />
            </ng-template>
        </p-dialog>
    `
})
export class RequiredUpdateComponent {
    readonly updates = inject(AppUpdateService);
}
